import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-report-s-arrow-down",
  "use": "app-icon-report-s-arrow-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-report-s-arrow-down\"><path d=\"M11.735 5h-7.47a.593.593 0 00-.455.972l3.735 4.482a.593.593 0 00.91 0l3.735-4.482A.593.593 0 0011.735 5z\" fill=\"#4D4D4D\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol